export default {
  // Placeholder endpoints as requested
  pendingRequests: (params) =>
    `payments/get-new-billed-payments?${new URLSearchParams(params)}`,
  history: (params) =>
    `payments/get-hisotrical-payments?${new URLSearchParams(params)}`,
  serviceTypes: (params) =>
    `payments/service-charge?${new URLSearchParams(params)}`,
  createRequest: "payments/new-payment-request",
  requestDetails: (id) => `payments/show-payment-request-details/${id}`,
};
